import { render } from "./환자권리존중및보호에관한선언문.vue?vue&type=template&id=758c3d12"
const script = {}

import "./환자권리존중및보호에관한선언문.vue?vue&type=style&index=0&id=758c3d12&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__